namespace e5.ScrollViewScale {
    class ScrollViewScaleContain implements IScrollViewScale {
        public getScale(view: ScrollView): number {
            var scX = view.width / view.contentWidth;
            var scY = view.height / view.contentHeight;
            return Math.min(scX, scY);
        }
    }

    export const Contain = new ScrollViewScaleContain();
}